import React, { useEffect, useState } from "react";
import Header from "./Header";
import './tech.css';
import { getdata_tech } from "../Api/api";
import Techmid from "./Techmid";
export default function Tech() {
  var [data_arr,set_data_arr]=useState([]);
  async function call() {
    var data =await  getdata_tech();
    console.log(data);
    set_data_arr(data.data);
    console.log(data_arr);
  }
  useEffect(()=>{
   call()
  },[])
  return (
    <div>
      <Header />
      <Techmid />
      <div className="Last_tech">
        {data_arr.length > 0 ? (
          data_arr.map((e, i) => {
            return (
              <div id="samelt" key={i}>
                <img
                  style={{
                    
                    boxShadow: "2px 2px 8px black",
                    border: "2px solid white",
                  }}
                  width="90%"
                  height="75%"
                  src={e.imgurl}
                />
                <h4 id="lth_4"> Title : {e.Title} </h4>
              </div>
            );
          })
        ) : (
          <div style={{ display: "flex" }}>
            <div id="samelt">
              {" "}
              <div id="lth_4">Check your servers or Refresh it</div>{" "}
            </div>
            <div id="samelt">
              {" "}
              <div id="lth_4">Check your servers or Refresh it</div>{" "}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}





